import React from 'react';
import { Link } from 'react-router-dom';
import { ApcMark } from '../components/ApcMark';
import { ShieldCheck } from 'lucide-react';

// Google "G" mark (official colors)
const GoogleG = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.9 32 29.4 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.8 0 5.4 1.1 7.3 2.8l5.7-5.7C33.6 7.1 29 5 24 5 13.5 5 5 13.5 5 24s8.5 19 19 19 19-8.5 19-19c0-1.2-.1-2.4-.4-3.5z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c2.8 0 5.4 1.1 7.3 2.8l5.7-5.7C33.6 7.1 29 5 24 5 16.3 5 9.7 9.3 6.3 14.7z"/>
    <path fill="#4CAF50" d="M24 43c5 0 9.5-1.9 12.9-5l-6-5.1C29 34.2 26.6 35 24 35c-5.4 0-9.9-3-11.3-7H6.1l-.1.1C9.3 38.7 15.9 43 24 43z"/>
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.6 1.8-1.8 3.4-3.4 4.5l6 5.1c-.4.4 6.5-4.8 6.5-13.6 0-1.2-.1-2.4-.4-3.5z"/>
  </svg>
);

const AdminLogin = () => {
  const startGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center p-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <ApcMark size={30}/><span className="font-bold" style={{ fontFamily: 'Outfit' }}>APC Admin</span>
        </Link>

        <div className="bg-white rounded-3xl border border-black/5 p-6 md:p-10">
          <div className="w-12 h-12 rounded-xl bg-[#1F6F4A]/10 flex items-center justify-center mb-5">
            <ShieldCheck size={22} className="text-[#1F6F4A]"/>
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-[#1B2A41] mb-2" style={{ fontFamily: 'Outfit' }}>
            Sign in to APC Admin
          </h1>
          <p className="text-sm text-[#4B5563] mb-7">
            Private administration portal. Access is restricted to authorised APC Owners only.
          </p>

          <button
            onClick={startGoogleLogin}
            className="w-full flex items-center justify-center gap-3 bg-white border-2 border-black/10 hover:border-black/30 rounded-full py-3.5 font-semibold text-[#1B2A41] transition-all active:scale-[0.98]"
            data-testid="continue-with-google"
          >
            <GoogleG size={20}/> Continue with Google
          </button>

          <p className="text-xs text-[#4B5563] mt-5 leading-relaxed">
            You will be redirected to Google to sign in. Only Google accounts on the APC Owner allowlist can access the admin portal — all other accounts are rejected server-side, even after a successful Google sign-in.
          </p>
        </div>

        <Link to="/" className="block text-center text-xs text-[#4B5563] mt-6 hover:text-[#1F6F4A]">← Back to the APC home page</Link>
      </div>
    </div>
  );
};

export default AdminLogin;
